/* content file: replace all html between <> </> with actual content */

import {ModulesUI} from "../components/ModulesUI"
import BracketHeader from "../components/BracketHeader"
import InfoWidget from "../components/InfoWidget"

const widgetText = { bold: "Mit einem Klick", normal: "auf die jeweiligen Module erfahren Sie mehr über deren Funktionen und Einsatzmöglichkeiten."}

export const Modules = () => { 
  return (
  <>
    <p className="mb-2">
      GA-Lotse ist modular aufgebaut und lässt sich flexibel an unterschiedliche Anforderungen und Verwaltungsprozesse anpassen. Das Grundmodul bildet die Basis und kann je nach Bedarf durch spezialisierte Fachmodule erweitert werden. Bereits verfügbare Module decken verschiedene Anwendungsbereiche ab. Weitere Module befinden sich in Vorbereitung.
    </p>
    {/* Title Bracket */}
    <BracketHeader title="GA-Lotse Modulwelt" subtitle="Vielfältig und anpassbar" className="mx-auto"/>
    {/* InfoWidget Smartphones */}
    <div className="w-full relative h-[80px] mt-8 sm:hidden flex scale-[.65] -translate-x-[4.5rem]"> 
      {/* <InfoWidget className="left-0 md:bottom-0 bottom-[-3em]" text={widgetText}/> */}
      <InfoWidget className="left-0 bottom-0" text={widgetText}/>
    </div>

    <ModulesUI />
    {/* InfoWidget Decktop */}
    <div className="w-full relative h-[80px] mt-8 sm:flex hidden"> 
      <InfoWidget className="left-14 md:bottom-0 lg:bottom-[3em] bottom-[-3em] mt-2 lg:left-28" text={widgetText}/>
    </div>
    {/* Modules */}
  </>    
  )
}